export default "__VITE_ASSET__2X8xWsek__"